function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
import util from './util';
var styles = util.styles;
/**
 * @hidden
 */
// @ts-ignore

var AnimationChild =
/** @class */
function (_super) {
  __extends(AnimationChild, _super);

  function AnimationChild() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(AnimationChild.prototype, "element", {
    /**
     * The element that is being animated.
     */
    get: function get() {
      return this._element;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * @hidden
   */

  AnimationChild.prototype.mounted = function () {
    // @ts-ignore
    this._element = this.$refs.element || null;
  };

  AnimationChild.prototype.onBeforeEnter = function (e) {
    this.$emit('enter', {
      animatedElement: e,
      target: this
    });
  };

  AnimationChild.prototype.onEnter = function (e) {
    this.animationStep = 'entering';
    this.$emit('entering', {
      animatedElement: e,
      target: this
    });
  };

  AnimationChild.prototype.onAfterEnter = function (e) {
    this.animationStep = 'entered';
    this.$emit('entered', {
      animatedElement: e,
      target: this
    });
  };

  AnimationChild.prototype.onBeforeLeave = function (e) {
    this.$emit('exit', {
      animatedElement: e,
      target: this
    });
  };

  AnimationChild.prototype.onLeave = function (e) {
    this.animationStep = 'exiting';
    this.$emit('exiting', {
      animatedElement: e,
      target: this
    });
  };

  AnimationChild.prototype.onAfterLeave = function (e) {
    this.animationStep = 'exited';
    this.$emit('exited', {
      animatedElement: e,
      target: this
    });
  };
  /**
   * @hidden
   */
  // @ts-ignore


  AnimationChild.prototype.render = function (h) {
    var _a = this.$props,
        appear = _a.appear,
        enter = _a.enter,
        exit = _a.exit,
        transitionName = _a.transitionName,
        transitionEnterDuration = _a.transitionEnterDuration,
        transitionExitDuration = _a.transitionExitDuration,
        className = _a.className,
        componentChildClassName = _a.componentChildClassName,
        mountOnEnter = _a.mountOnEnter,
        unmountOnExit = _a.unmountOnExit,
        animationEnteringStyle = _a.animationEnteringStyle,
        animationEnteredStyle = _a.animationEnteredStyle,
        animationExitingStyle = _a.animationExitingStyle,
        animationExitedStyle = _a.animationExitedStyle,
        other = __rest(_a, ["appear", "enter", "exit", "transitionName", "transitionEnterDuration", "transitionExitDuration", "className", "componentChildClassName", "mountOnEnter", "unmountOnExit", "animationEnteringStyle", "animationEnteredStyle", "animationExitingStyle", "animationExitedStyle"]);

    var hasChildren = !!this.$slots.default;
    var childAnimationContainerClassNames = [componentChildClassName, styles['child-animation-container']];

    var defaultStyle = __assign({
      transitionDelay: '0ms',
      transitionDuration: hasChildren ? transitionEnterDuration + "ms" : transitionExitDuration + "ms"
    }, this.$props.transitionStyle);

    var animationStyle = {
      entering: __assign({
        transitionDuration: transitionEnterDuration + "ms"
      }, animationEnteringStyle),
      entered: __assign({}, animationEnteredStyle),
      exiting: __assign({
        transitionDuration: transitionExitDuration + "ms"
      }, animationExitingStyle),
      exited: __assign({}, animationExitedStyle)
    };
    var childElementStyles = [defaultStyle, animationStyle[this.animationStep]];
    var enterDuration = enter ? transitionEnterDuration : 0;
    var exitDuration = exit ? transitionExitDuration : 0;
    var duration = {
      enter: enterDuration,
      leave: exitDuration
    };
    return h("transition", {
      attrs: {
        duration: duration,
        name: transitionName,
        appear: appear,
        appearClass: styles[transitionName + "-appear"] || transitionName + "-appear",
        appearToClass: styles[transitionName + "-appear-active"] || transitionName + "-appear-active",
        enterClass: styles[transitionName + "-enter"] || transitionName + "-enter",
        enterToClass: styles[transitionName + "-enter-active"] || transitionName + "-enter-active",
        leaveClass: styles[transitionName + "-exit"] || transitionName + "-exit",
        leaveToClass: styles[transitionName + "-exit-active"] || transitionName + "-exit-active"
      },
      on: {
        "beforeEnter": this.onBeforeEnter,
        "enter": this.onEnter,
        "afterEnter": this.onAfterEnter,
        "beforeLeave": this.onBeforeLeave,
        "leave": this.onLeave,
        "afterLeave": this.onAfterLeave
      }
    }, [hasChildren ? h("div", {
      style: childElementStyles,
      "class": childAnimationContainerClassNames,
      ref: 'element'
    }, [this.$slots.default]) : null, "}}"]);
  };

  AnimationChild = __decorate([Component({
    props: {
      in: Boolean,
      transitionName: {
        type: String,
        required: true
      },
      transitionStyle: Object,
      componentChildClassName: [String, Array],
      className: String,
      appear: {
        type: Boolean,
        default: true
      },
      enter: {
        type: Boolean,
        default: true
      },
      exit: {
        type: Boolean,
        default: true
      },
      transitionEnterDuration: Number,
      transitionExitDuration: Number,
      mountOnEnter: Boolean,
      unmountOnExit: Boolean,
      animationEnteringStyle: Object,
      animationEnteredStyle: Object,
      animationExitingStyle: Object,
      animationExitedStyle: Object
    }
  })], AnimationChild);
  return AnimationChild;
}(VueComponent);

export { AnimationChild };